import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'ArchivoConstructionInfo',
    endpoint: 'archivo_construction_infos',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoConstructionInfo",
    modelNameProperty: 'nombreFichero'
})
export class ArchivoConstructionInfo extends Archivo {
    public static readonly PEDIDO_MAP: PropertyMap = {
        name: 'Linea Pedido',
        type: PropertyType.FutureUri('linea-pedido.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoConstructionInfo.PEDIDO_MAP)
    private _lineaPedido;

    // public static readonly SOLICITUD_MAP: PropertyMap = {
    //     name: 'Linea Solicitud',
    //     type: PropertyType.FutureUri('linea-solicitud.model.ts'),
    //     readWrite: ReadWrite.ReadOnly
    // }
    // @BasicProperty(ArchivoSTL.SOLICITUD_MAP)
    // private _lineaSolicitud;

    get lineaPedido() {
        return this._lineaPedido;
    }

    set lineaPedido(value) {
        this._lineaPedido = value;
    }

    // get lineaSolicitud() {
    //     return this._lineaSolicitud;
    // }
    //
    // set lineaSolicitud(value) {
    //     this._lineaSolicitud = value;
    // }
}
